import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import OrderConsolidateModal, { IStateProps, IDispatchProps, IOwnProps } from './OrderConsolidateModal'
import { IStoreState } from '../../services/store/IStoreState'
import { DashboardAction, requestCreateLabels } from '../../services/store/actions/dashboard/DashboardAction'

function mapStateToProps(): IStateProps {
  return {}
}

function mapDispatchToProps(dispatch: Dispatch<DashboardAction>): IDispatchProps {
  return {
    requestCreateLabels: (products) => dispatch(requestCreateLabels({ products })),
  }
}

export default connect<IStateProps, IDispatchProps, IOwnProps, IStoreState>(
  mapStateToProps,
  mapDispatchToProps
)(OrderConsolidateModal)
